export default __webpack_public_path__ + "static/media/Twitter-s-icon.fc6c7709.svg";